import { atom } from 'jotai'
import { userType } from '@/lib/definitions/definitions';

export const userState = atom<userType>({
        identifiedBy: null,
        identifier: null,
        id: null,
        email: null,
        role: null,
        isAdmin: null,
        isSuperAdmin: null,
        firstName: null,
        lastName: null,
        birthDate: null,
        country: null,
        lang: null,
        signatures: null,
        division: null,
        lastLogin: null,
        status: null,
        securityToken: null,
        active: true
});
